import React from 'react';

import moment from 'moment';

import { DataProviderModal, getCombinedLatestAndError, TIMESTAMP_UI_DATE_FORMAT } from './DataProviderModal';
import { ClockCheck } from '../../../../common/icons/ClockCheck';

export const DataProviderTimestampButton = ({ account }) => {
  const adsProviders = account.adsProviders.filter((p) => !p.generated);
  const { productProviders } = account;

  const { latestSync } = getCombinedLatestAndError(adsProviders, productProviders);

  return (
    <DataProviderModal account={account}>
      <span style={{ fontSize: '0.8rem', cursor: 'pointer' }}>
        <ClockCheck style={{ top: '0.3rem', position: 'relative', marginRight: '0.4rem' }}></ClockCheck>
        {!latestSync ? 'N/A' : moment(latestSync).format(TIMESTAMP_UI_DATE_FORMAT)}
      </span>
    </DataProviderModal>
  );
};
